import { AttendanceServiceEnum } from "../../attendance/enums/attendance-cau.enum";

export class UpdateAttendanceDayRequest {
    schoolId: number;
    exerciseId: number;
    serviceId: number;
    studentId: number;
    year: number;
    month: number;
    day: number;
    attendanceState: AttendanceServiceEnum;
}